"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeShiftPresetStartAndEndCommand = void 0;
const ddd_library_1 = require("@hoepel.app/ddd-library");
const types_1 = require("@hoepel.app/types");
class ChangeShiftPresetStartAndEndCommand extends ddd_library_1.CommandBase {
    constructor() {
        super(...arguments);
        this.name = 'change-shift-preset-start-and-end-command';
    }
    static create(presetName, startAndEnd, commandMetadata) {
        const startMinutesSinceMidnight = startAndEnd.start.minute + startAndEnd.start.hour * 60;
        const endMinutesSinceMidnight = startAndEnd.end.minute + startAndEnd.end.hour * 60;
        return new ChangeShiftPresetStartAndEndCommand({ presetName, startMinutesSinceMidnight, endMinutesSinceMidnight }, commandMetadata);
    }
    get startAndEndTime() {
        const startMinutes = this.payload.startMinutesSinceMidnight % 60;
        const startHours = (this.payload.startMinutesSinceMidnight - startMinutes) / 60;
        const endMinutes = this.payload.endMinutesSinceMidnight % 60;
        const endHours = (this.payload.endMinutesSinceMidnight - endMinutes) / 60;
        return new types_1.StartAndEndTime({
            start: { hour: startHours, minute: startMinutes },
            end: { hour: endHours, minute: endMinutes },
        });
    }
    get presetName() {
        return this.payload.presetName;
    }
}
exports.ChangeShiftPresetStartAndEndCommand = ChangeShiftPresetStartAndEndCommand;
//# sourceMappingURL=change-shift-preset-start-and-end.command.js.map